<template>
  <span
    class="ui_icon"
    :style="{
      '--icon-size': `${size}px`,
      '--icon-url': `url(${sourceUrl})`,
      '--icon-color': color,
    }"
    :aria-label="altText || `Icono ${name}`"
  />
</template>
<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
    },
    altText: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 16,
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    sourceUrl() {
      return require(`@/assets/icons/${this.name}.svg`)
    },
  },
}
</script>
<style>
.ui_icon {
  display: inline-block;
  height: var(--icon-size);
  width: var(--icon-size);
  min-width: var(--icon-size);
  mask-image: var(--icon-url);
  color: var(--icon-color);
  -webkit-mask-image: var(--icon-url);
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
  background-color: currentColor;
}
</style>
